// extracted by mini-css-extract-plugin
export default {"title":"modal_confirmation_header_no_close-module__title--245Vi"};